import React from 'react';
import {withRouter} from "react-router-dom"
import {BodySm, TitleXl, TitleMd,  Row, Col8, Col4} from "components/elements";
import {AboutUsPurpleSectionContainer, TitleXlContainer, LeftCircleContainer, RightCircleContainer, MiddleCircleContainer} from './elements';
import OverlapCircles from 'components/OverlapCircles';

function AboutUsPurpleSection(props) {

return(
        <AboutUsPurpleSectionContainer title="">
            <TitleXlContainer>
                <TitleXl fontWeight="900">Not to brag, but we’re a pretty big deal<span className="magenta">.</span>  </TitleXl>
            </TitleXlContainer>
            <Row  alignItems="start">
                <Col4>
                    <TitleMd>
                        Trusted by the best. Respected by our peers. 
                    </TitleMd>
                    <BodySm>
                    We work with the top 30 pharma and biotech companies. And we've had 20 years of double-digit growth. We're supported by thousands of experts across a broad range of healthcare specialties. Fast Company has ranked us #2 as the most innovative in data sciences, Cannes Lions as the #3 most creative in health and MM+M as the #1 medical marketing agency, which means we don't just do it all, we do it all really well.
                    </BodySm>
                </Col4>
                <Col8>
                <MiddleCircleContainer>
                        <OverlapCircles borderColor="#fff" dimensionsDesktop="400px" dimensionsMobile="210px" mobileBorder="8px solid #FFFFFF" largePurpleCircles="true" titleMd="#2" titleSmTop="MOST INNOVATIVE IN DATA SCIENCES" titleSmBottom="(AI)" imageSource="/images/fast-company-logo.svg" alt="Fast Company logo"/>
                </MiddleCircleContainer>  
                 <LeftCircleContainer>
                        <OverlapCircles borderColor="#fff" dimensionsDesktop="400px" dimensionsMobile="210px"  mobileBorder="8px solid #FFFFFF" largePurpleCircles="true" titleMd="#1" titleSmTop="MEDICAL MARKETING AGENCY"  imageSource="/images/MM-M-Logo.svg" alt="MM+M Agency 100 2023" />
                    </LeftCircleContainer>
                    <RightCircleContainer>
                            <OverlapCircles borderColor="#fff" dimensionsDesktop="400px" dimensionsMobile="210px"  mobileBorder="8px solid #FFFFFF" largePurpleCircles="true" titleMd="#3" titleSmTop="MOST CREATIVE IN HEALTH" titleSmBottom="(IDEAS)" imageSource="/images/cannes-lion-logo.svg" alt="Cannes Lions logo" />
                    </RightCircleContainer>                       
                </Col8>
            </Row>
          
        </AboutUsPurpleSectionContainer>
    )
}

export default withRouter(AboutUsPurpleSection);
